module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/v/product.svg?1f2da47deca58c7929f80535274d1e92";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/v/product.svg
// module id = 87
// module chunks = 0